export default "__VITE_ASSET__D7RZWMm0__"